import { jsx as M } from "react/jsx-runtime";
import { createContext as b, useMemo as s } from "react";
import { toArray as C } from "../../helpers/formatting/toArray.js";
import { useControlledState as A } from "../../hooks/useControlledState.js";
const N = b(
  void 0
), w = ({
  changeOnBlur: n,
  children: x,
  defaultSelected: f,
  id: r,
  layout: c,
  multiSelect: o,
  nav: d = !1,
  noWrap: i,
  onChange: l,
  role: e,
  selected: v
}) => {
  const u = s(
    () => e && ["menu", "listbox"].includes(e),
    [e]
  ), p = s(
    () => e === "listbox" || !!o,
    [e, o]
  ), { toggleValue: a, value: t } = A({
    component: "IressMenu",
    defaultValue: f,
    multiple: o,
    onChange: l,
    propName: "selected",
    value: v
  }), g = s(
    () => ({
      changeOnBlur: n && e === "listbox",
      hasArrowKeyNav: u,
      id: r,
      isSelected: (m) => m !== void 0 && C(t).includes(m),
      layout: c,
      multiSelect: o,
      noWrap: i,
      nav: d,
      role: e,
      selected: t,
      supportsSelection: p,
      toggle: a
    }),
    [
      n,
      u,
      r,
      c,
      o,
      d,
      i,
      e,
      t,
      p,
      a
    ]
  );
  return /* @__PURE__ */ M(N.Provider, { value: g, children: x });
};
export {
  N as MenuContext,
  w as MenuProvider
};
